export const topBarHeight = 64
export const sideNavWidth = 260
export const navbarHeight = 60
export const sidenavCompactWidth = 80
export const containedLayoutWidth = 1200
export const baseUrl = "https://handle-erp.tech-and-beyond.org/"
export const fileUrl = "https://handle-erp.tech-and-beyond.org/uploads/"
//export const baseUrl = "http://localhost:5000/"
//export const fileUrl = "http://localhost:5000/uploads/"
export const apiVersion1 = "api/admin/"